import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
    const path = to.path;
    let normalized = path;

    // Get last segment of path
    const lastSegment = path.split('/').filter(Boolean).pop() || '';

    // If last segment has a dot (potential file extension)
    if (lastSegment.includes('.')) {
        // Check if it's .html - redirect those
        if (path.endsWith('.html')) {
            normalized = path.replace(/\.html$/i, '');
            return navigateTo(
                {
                    path: normalized,
                    query: to.query,
                    hash: to.hash,
                },
                {
                    redirectCode: 301,
                }
            );
        }

        // Any other extension in last segment = 404
        return showError({
            statusCode: 404,
            statusMessage: 'Page Not Found',
        });
    }

    // Replace multiple slashes with a single slash
    normalized = normalized.replace(/\/{2,}/g, '/');

    // Remove trailing slash (except for root)
    if (normalized.length > 1 && normalized.endsWith('/')) {
        normalized = normalized.replace(/\/+$/, '');
    }

    if (normalized !== path) {
        return navigateTo(
            {
                path: normalized,
                query: to.query,
                hash: to.hash,
            },
            {
                redirectCode: 301,
            }
        );
    }
});
